// Make sure to install the package if not already done
// npm install @availity/mui-icon

import {
  FileArchiveIcon,
  FileCodeIcon,
  FileCsvIcon,
  FileExcelIcon,
  FileIcon,
  FileImageIcon,
  FileLinesIcon,
  FilePdfIcon,
  FilePowerpointIcon,
  FileWordIcon,
} from '@availity/mui-icon';

export function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${Number.parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
}

// No type declaration needed in JavaScript
export const FILE_EXT_ICONS = {
  png: FileImageIcon,
  jpg: FileImageIcon,
  jpeg: FileImageIcon,
  gif: FileImageIcon,
  csv: FileCsvIcon,
  ppt: FilePowerpointIcon,
  pptx: FilePowerpointIcon,
  xls: FileExcelIcon,
  xlsx: FileExcelIcon,
  doc: FileWordIcon,
  docx: FileWordIcon,
  txt: FileLinesIcon,
  text: FileLinesIcon,
  zip: FileArchiveIcon,
  '7zip': FileArchiveIcon,
  xml: FileCodeIcon,
  html: FileCodeIcon,
  pdf: FilePdfIcon,
};

// Function to check if a key is valid, removing the TypeScript type guard
export const isValidKey = (key) => (key ? key in FILE_EXT_ICONS : false);

// Determine the icon based on the file extension
export const getFileExtIcon = (fileName) => {
  const ext = fileName.split('.').pop()?.toLowerCase() || '';
  const icon = isValidKey(ext) ? FILE_EXT_ICONS[ext] : FileIcon;

  return icon;
};

export const getActiveCodeValuesByPath = (data, path) => {
  const codeValues = data?.find((obj) => obj.path.toLowerCase() === path.toLowerCase())?.codeValues || [];
  return (codeValues || []).filter((item) => item.active);
};
